import React from 'react'
import style from '../../components/Analysis/Tabs/InitialTab/style.module.sass'
import { useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import config from '../../config'

export default function NewsMultilang () {
  const { theme: { bgColors, colors } } = useTheme()
  const { t } = useTranslation()
  const theme = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const newsBlock = `analyse-news-block-${theme}`
  return (
    <div className={`m-2 mt-0 ${style.textNews}`}>
      <div style={{ backgroundColor: bgColors.bgPrimary0 }} className={`${style.info} mb-4`}>
        <div style={{ backgroundColor: bgColors.bgPrimary0, color: colors.colorText }} className={`${style.info} mb-4`}
             dangerouslySetInnerHTML={{
               __html: t(newsBlock, {
                 color: colors.colorPrimary500,
                 info_count_text: style.info_count_text
               })
             }}/>
      </div>
    </div>
  )
}